module.exports = __webpack_public_path__ + "static/media/smoothie_paper_straw1.07fbbbbc.png";